import React from "react";
import { Box, Grid, TextField, Typography } from "@mui/material";
import { formatPhoneNumber } from "../../../utils/validation";

const StepCustomerInfo = ({ formData, setFormData, errors = {} }) => {
  const handleChange = (field) => (e) => {
    const value =
      field === "phone" ? formatPhoneNumber(e.target.value) : e.target.value;
    setFormData((prev) => ({
      ...prev,
      customer: {
        ...prev.customer,
        [field]: value,
      },
    }));
  };

  return (
    <Box>
      <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 2 }}>
        Customer Information
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            label="First Name"
            fullWidth
            value={formData.customer.firstName}
            onChange={handleChange("firstName")}
            error={!!errors.firstName}
            helperText={errors.firstName}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Last Name"
            fullWidth
            value={formData.customer.lastName}
            onChange={handleChange("lastName")}
            error={!!errors.lastName}
            helperText={errors.lastName}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Email"
            fullWidth
            value={formData.customer.email}
            onChange={handleChange("email")}
            error={!!errors.email}
            helperText={errors.email}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Phone Number"
            fullWidth
            value={formData.customer.phone}
            onChange={handleChange("phone")}
            error={!!errors.phone}
            helperText={errors.phone}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default StepCustomerInfo;
